import { render, staticRenderFns } from "./WMS.vue?vue&type=template&id=61bd202d&scoped=true"
import script from "./WMS.vue?vue&type=script&lang=js"
export * from "./WMS.vue?vue&type=script&lang=js"
import style0 from "./WMS.vue?vue&type=style&index=0&id=61bd202d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bd202d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61bd202d')) {
      api.createRecord('61bd202d', component.options)
    } else {
      api.reload('61bd202d', component.options)
    }
    module.hot.accept("./WMS.vue?vue&type=template&id=61bd202d&scoped=true", function () {
      api.rerender('61bd202d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/softBusinessLogistics/WMS.vue"
export default component.exports